.q{overflow:hidden;}